import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import loadingBarImage from '../../../images/loadingBar.gif';
import * as irActions from '../../../redux/actions/irSearch';


class DocketParts extends Component {
  onDownloadZipClick = () => {
    const { case_uuid, docket_numbers } = this.props;

    const params = {
      case_uuid,
      docket_numbers: [docket_numbers],
      download_option: 1,
    };

    this.props.dispatch(irActions.getDocketParts(params));

    // todo rename this popup to be the title
    this.props.onPopupClick({
      name: 'DownloadZipAllPdfsRangePopup',
      show: true,
      data: params,
    });
  }

  onDownloadComboPdfClick = () => {
    const { case_uuid, docket_numbers } = this.props;

    const params = {
      case_uuid,
      docket_numbers: [docket_numbers],
      download_option: 1,
    };

    this.props.dispatch(irActions.getDocketParts(params));

    this.props.onPopupClick({
      name: 'DownloadCombineAllPdfInRangePopup',
      show: true,
      data: params,
    });
  }

  onDownloadEmailZipClick = () => {
    const { case_uuid, docket_numbers } = this.props;

    const params = {
      case_uuid,
      docket_numbers: [docket_numbers],
      download_option: 1,
    };

    this.props.onPopupClick({
      name: 'EmailAllPartsZipPopup',
      show: true,
      data: params,
    });
  }

  onEmailCombinedPdf = () => {
    const { case_uuid, docket_numbers } = this.props;

    const params = {
      case_uuid,
      docket_numbers: [docket_numbers],
      // download_option: 1,
    };

    this.props.onPopupClick({
      name: 'EmailCombinedPdfPopup',
      show: true,
      data: params,
    });
  }

  onPopupClick = (name) => {
    const { case_uuid, docket_numbers } = this.props;
    const params = {
      name,
      show: true,
      data: {
        case_uuid,
        docket_numbers,
        download_option: 1,
      },
    };

    this.props.onPopupClick(params);
  }

  allPartsPrintPreview = (name) => {
    const { case_uuid, docket_numbers } = this.props;

    const params = {
      case_uuid,
      'docket_numbers[]': docket_numbers,
    };

    this.props.dispatch(irActions.getDocketParts(params));
    this.onPopupClick(name);
  }

  printPreview = (case_uuid, docket_no, number, friendly_name) => {
    const url = `/ir-documentselect/print_pdf/docket/${case_uuid}/${docket_no}/${number}/${friendly_name}`;
    const win = window.open(url);
    if (!(/Chrome/.test(navigator.userAgent))) {
      win.print();
    }
    win.addEventListener('load', this.props.reloadDetails, true);
  }

  emailPartPopup = (friendly_name, docket_no, part_number) => {
    const { case_uuid } = this.props;

    const params = {
      name: 'EmailPartPopup',
      show: true,
      data: {
        case_uuid,
        friendly_name,
        docket_no,
        part_number,
      },
    };

    this.props.onPopupClick(params);
  }

  downloadFile = (download_url) => {
    window.location = download_url;
    // add a delay since it takes a bit to know the link was called
    window.setTimeout(this.props.reloadDetails, 500);
  }

  render() {
    const { details } = this.props.docketDetails;

    const rows = details.map((p, i) => {
      let row = null;
      if (p.download_url) {
        row = (
          <tr>
            <td style={{ whiteSpace: 'nowrap' }}>
              <div id="download"
                   title="Download File"
                   onClick={this.downloadFile.bind(null, p.download_url)}>
                <span className="download icon" />
              </div>
              <div className="email-pdf"
                   onClick={this.emailPartPopup.bind(null, p.friendly_name, p.docket_no, p.number)}
                   id="email"
                   title="Email">
                <span className="email icon" />
              </div>
              <a href="#"
                 onClick={this.printPreview.bind(null, p.case_uuid, p.docket_no, p.number, p.friendly_name)}
                 id="print"
                 title="Print preview">
                <span className="preview icon" />
              </a>
            </td>
          </tr>
        );
      } else if (p.isLoading) {
        row = (
          <div className="loading-bar">
            <img src={loadingBarImage} />
          </div>
        );
      } else {
        row = (
          <button onClick={this.props.buyPdf.bind(null, p.docket_no, p.number, p.sequence_number)}
                  className="form-submit green">Buy ${p.cost}
          </button>
        );
      }

      return (
        <tr className="odd" key={`docket-detail-${i}`}>
          <td />
          <td>{ p.number }</td>
          <td>{ p.description_html || 'Docket' }</td>
          <td>{ p.pages }</td>
          <td style={{ whiteSpace: 'nowrap' }}>
            { row }
          </td>
        </tr>
      );
    });

    if (details.length > 1) {
      const bulk = (
        <tr className="bulk-operations odd">
          <td />
          <td />
          <td>All parts</td>
          <td>3</td>
          <td className="bulk-operations">
            <div className=" menu">
              <div className="ui delayed dropdown item">
                <span className="download icon" /> &nbsp;
                <span className="email icon" /> &nbsp;
                <span className="preview icon" /> ...
                <div className="menu" style={{ display: 'block' }}>
                  <div className="item" onClick={this.onDownloadZipClick}><span
                    className="download icon" />
                    <span className="zip icon right" /> Download ZIP
                  </div>
                  <div className="item" onClick={this.onDownloadComboPdfClick}>
                    <span className="download icon" />
                    <span className="pdf icon right" />
                     Download Combined PDF &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <div className="item" onClick={this.onDownloadEmailZipClick}>
                    <span className="email icon" />
                    <span className="zip icon right" /> Email ZIP
                  </div>
                  <div className="item" onClick={this.onEmailCombinedPdf}>
                    <span className="email icon" />
                    <span className="pdf icon right" /> Email Combined PDF
                  </div>
                  <div className="item" onClick={this.allPartsPrintPreview.bind(null, 'AllPartsPrintPreview')}>
                    <span className="preview icon" /> Print Preview
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );

      rows.push(bulk);
    }
    return rows;
  }
}

DocketParts.propTypes = {
  docketDetails: PropTypes.object.isRequired,
  buyPdf: PropTypes.func.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  case_uuid: PropTypes.string.isRequired,
  docket_numbers: PropTypes.any.isRequired,
  reloadDetails: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup } = state.get('dockets').toJS();

  return {
    popup,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DocketParts);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/DocketParts.jsx
 **/